import React, { useCallback, useMemo, useState } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import Divider from '../../../../components/atoms/Divider'
import PageHeading from '../common/PageHeading'
import PageLayout from '../common/PageLayout'
import DebouncedInput from '../../../../components/molecules/DebouncedInput'
import Loading from '../../../../components/molecules/Loading'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import NoResults from '../common/NoResults'
import { useGetAiSkills } from '../../../../api/denaliAssistant'
import SkillCard from './SkillCard'

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    width: '35%',
    minWidth: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  grid: {
    marginTop: theme.spacing(2)
  },
  gridItem: {
    display: 'flex',
    height: 'auto',
    minHeight: '240px',
    marginBottom: theme.spacing(2)
  }
}))

function SkillsHome () {
  const classes = useStyles()
  const [searchQuery, setSearchQuery] = useState('')
  const { data: skillsData, isLoading } = useGetAiSkills({
    allVersions: false,
    skip: 0,
    take: 1000
  })

  const visibleSkills = useMemo(() => {
    if (!skillsData?.skills) return []

    const searchLower = searchQuery.toLowerCase().trim()
    return skillsData.skills
      .filter(skill => {
        const content = skill.skillContent || {}
        return content.enabled !== false
      })
      .filter(skill => {
        if (!searchLower) return true
        const nameMatch = skill.skillName?.toLowerCase().includes(searchLower)
        const descMatch = skill.skillContent?.description?.toLowerCase().includes(searchLower)
        return nameMatch || descMatch
      })
  }, [skillsData, searchQuery])

  const handleSearchChange = useCallback((debouncedValue) => {
    setSearchQuery(debouncedValue?.value ?? debouncedValue ?? '')
  }, [])

  if (isLoading) {
    return (
      <PageLayout variant='constrained'>
        <Loading />
      </PageLayout>
    )
  }

  return (
    <PageLayout variant='constrained'>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <PageHeading title='Skills'>
            <div className={classes.searchContainer}>
              <DebouncedInput
                placeholder='Search skills...'
                defaultValue={searchQuery}
                onChange={handleSearchChange}
                delay={300}
                style={{ minWidth: 'unset', width: '100%' }}
              />
            </div>
          </PageHeading>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          {visibleSkills.length === 0 ? (
            <NoResults message='No skills available' />
          ) : (
            <FadeIn>
              <Grid container spacing={4} className={classes.grid}>
                {visibleSkills.map((skill) => (
                  <Grid item xs={12} sm={6} md={3} key={`${skill.skillId}-${skill.version}`} className={classes.gridItem}>
                    <SkillCard skill={skill} />
                  </Grid>
                ))}
              </Grid>
            </FadeIn>
          )}
        </Grid>
      </Grid>
    </PageLayout>
  )
}

export default SkillsHome
